import { render } from "./LinkedContactsTab.vue?vue&type=template&id=da092ffa&scoped=true"
import script from "./LinkedContactsTab.vue?vue&type=script&lang=js"
export * from "./LinkedContactsTab.vue?vue&type=script&lang=js"

import "./LinkedContactsTab.vue?vue&type=style&index=0&id=da092ffa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da092ffa"]])

export default __exports__